import { Component, OnInit, Input, APP_INITIALIZER } from '@angular/core'
import { confirm } from 'devextreme/ui/dialog';
import { FacilityService } from '../services/facility.service';
import { BusinessPotential } from '../types/BusinessPotential';
import { Facility } from '../types/Facility';
import { FacilityDetail } from '../types/FacilityDetail';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from 'src/app/common/component/notification/notification.service';
import { SharedComponentService } from 'src/app/common/service/sharedcomponent.service';
import { SharedService } from "src/app/services/SharedService";
import { IndustrialGasUOM } from '../types/IndustrialGasUOM';
import { Coordinates } from "src/app/plant/types/Location";

@Component({
  selector: 'facility',
  templateUrl: './facility.component.html',
  styleUrls: ['./facility.component.scss']
})
export class FacilityComponent implements OnInit {
  facilityTypes: string[];
  facilityStatuses: string[];
  colCountByScreen: Object;
  facility: Facility;
  isLoadPanelVisible: boolean = false;
  isToastVisible: boolean = false;
  isNewFacility: boolean = false;
  isFacilityDisabled: boolean = false;
  isAnyEquipmentAttached: boolean = false;
  toastMessage: string;
  industrialGasUOMs: IndustrialGasUOM[];
  type = 'success';
  Coordinates: Coordinates = new Coordinates();
  mapsPopupVisible: boolean;
  isMapViewAvailable: boolean;

  constructor(private facilityService: FacilityService, private notificationService: NotificationService,
    private route: ActivatedRoute, private router: Router, private sharedComponentService: SharedComponentService,
    private sharedsvc: SharedService) {
    this.facilityTypes = ['General', 'LASU', 'HYCO'];
    this.facilityStatuses = ['Prospect', 'Awarded'];
    this.facility = new Facility();
    this.facility.actualsEdited = false;
    this.facility.facilityType = this.facilityTypes[0]
    this.facility.productionFacilityId = -1;
    this.facility.facilityStatus = this.facilityStatuses[0];
    this.initialize();

    this.facilityService.GetIndustrialGasUOMs()
      .subscribe(
        (data: IndustrialGasUOM[]) => {
          this.industrialGasUOMs = data;
        }
      );
  }

  initialize() {
    this.facility.facilityDetail = new FacilityDetail();
    this.facility.facilityDetail.attachments = [];
    this.facility.businessPotential = new BusinessPotential();
    this.facility.businessPotential.bidCompanies = [];
    this.facility.facilityDetail.productionActivityId = null;
    this.facility.facilityDetail.activityProcessFeedstockId = null;
    this.facility.facilityDetail.businessCatogoryId = null;

    this.facility.equipments = [];
    this.facility.businessPotential.apAmenable = false;
    this.facility.businessPotential.apBid = false;
    this.facility.facilityDetail.igccFlag = false;
    this.facility.facilityDetail.acquisitionOpportunityFlag = false;
    this.facility.facilityDetail.replacementOpportunityFlag = false;
    this.facility.businessPotential.lastContactedBy = ''
    this.facility.businessPotential.opportunityLead = ''
    this.facility.facilityDetail.sourceLinks = [];
    this.facility.facilityDetail.attachments = [];
  }

  ngOnInit(): void {
    this.isLoadPanelVisible = true;
    this.sharedComponentService.sendEvent();
    this.facility.siteId = +this.route.snapshot.params['siteid'];
    this.facility.productionFacilityId = +this.route.snapshot.params['facilityid'];
    this.facility.equipmentUpdated = (this.route.snapshot.queryParamMap.get('equipmentUpdated') === 'true');
    if (Number.isNaN(this.facility.productionFacilityId)) {
      this.isNewFacility = true;
      this.facility.productionFacilityId = -1;
    } else {
      this.isNewFacility = false;
    }

    this.facilityService.getSiteAndProvince(this.facility.siteId)
      .subscribe(
        (data: Facility) => {
          this.facility = { ...data, ...this.facility };
          if (this.isNewFacility) {
            this.isLoadPanelVisible = false;
            this.facility.activeFlag = true;
          }
        });

    if (this.isNewFacility === false) {
      this.facilityService.LoadProductionFacility(this.facility.productionFacilityId)
        .subscribe(
          (data: Facility) => {
            this.facility = { ...this.facility, ...data };
            if (this.facility.businessPotential === null) {
              this.facility.businessPotential = new BusinessPotential();
            }

            if (this.facility.businessPotential.bidCompanies === undefined || this.facility.businessPotential.bidCompanies === null) {
              this.facility.businessPotential.bidCompanies = [];
            }

            if (this.facility.facilityDetail.generateMerchantLiquid === undefined || this.facility.facilityDetail.generateMerchantLiquid === null) {
              this.facility.facilityDetail.generateMerchantLiquid = false;
            }
            if (this.facility.equipments === null || this.facility.equipments === undefined || this.facility.equipments.length <= 0) {
              this.isAnyEquipmentAttached = false;
            } else {
              this.isAnyEquipmentAttached = true;
            }

            if (this.facility.facilityDetail.igccFlag === null || this.facility.facilityDetail.igccFlag === undefined) {
              this.facility.facilityDetail.igccFlag = false;
            }

            if (this.facility.facilityDetail.acquisitionOpportunityFlag === null || this.facility.facilityDetail.acquisitionOpportunityFlag === undefined) {
              this.facility.facilityDetail.acquisitionOpportunityFlag = false;
            }

            if (this.facility.facilityDetail.replacementOpportunityFlag === null || this.facility.facilityDetail.replacementOpportunityFlag === undefined) {
              this.facility.facilityDetail.replacementOpportunityFlag = false;
            }
            this.isLoadPanelVisible = false;
          }
        )
    }
  }

  screen(width) {
    return (width < 700) ? 'sm' : 'lg';
  }

  Save() {
    this.isLoadPanelVisible = true;

    // Apply facility status logic before saving
    this.applyFacilityStatusLogic();

    this.facilityService.saveFacility(this.facility)
      .subscribe((data: number) => {
        if (data !== null && data !== undefined) {
          this.notificationService.alert('success', `Saved successfully`, `Facility ID: ${data}`);
          this.isToastVisible = true;
          setTimeout(() => { this.navigateToSiteSummary(); }, 3000);
        }
        this.isLoadPanelVisible = false;
      });
  }

  navigateToSiteSummary() {
    this.router.navigate([`/sitesummary/${this.facility.siteId}`]);
  }

  navigateToPlants() {
    this.router.navigate([`/plants`]);
  }

  changeLoadPanelIndicator(visibleFlag: boolean) {
    this.isLoadPanelVisible = visibleFlag;
  }

  Discard() {
    let that = this;
    var result = confirm("Your changes will be lost. Are you sure?", "Confirm");
    result.then(function (dialogResult) {
      if (dialogResult) {
        if (that.sharedsvc.previousRouteToEditFacility == "plants") {
          that.navigateToPlants();
        } else {
          that.navigateToSiteSummary();
        }
      }
    });
  }

  Delete() {
    let that = this;
    var result = confirm("This facility will be disabled permanantly. Are you sure?", "Confirm");
    result.then(function (dialogResult) {
      if (dialogResult) {
        that.isLoadPanelVisible = true;
        that.facilityService.deleteFacility(that.facility.productionFacilityId)
          .subscribe(
            (data: number) => {
              if (data !== null && data !== undefined) {
                that.toastMessage = "Facility disabled permanantly"
                that.isToastVisible = true;
                setTimeout(() => { that.navigateToPlants(); }, 3000);
              }
              that.isLoadPanelVisible = false;

            });
      }
    });
  }

  onSiteIdClicked() {
    this.sharedsvc.previousRouteToEditSite = "";
    this.route.url.forEach(value => {
      this.sharedsvc.previousRouteToEditSite += value;
    });
    this.sharedsvc.previousRouteToEditSite = this.sharedsvc.previousRouteToEditSite.replace(/,/g, '/');
    this.router.navigate([`/editsite/${this.facility.siteId}`]);
  }

  mapview() {
    this.facilityService.getCoordinates(this.facility.siteId).subscribe({
      next: data => {
        this.Coordinates.latitude = data.latitude;
        this.Coordinates.longitude = data.longitude;
        this.mapsPopupVisible = true;
      }, error: error => {
        this.notificationService.alert("error", "Error while fetching Coordinates for the Site.", error);
        this.isLoadPanelVisible = false;
      }
    });

  }

  setmapsPopupVisibility(isVisible) {
    this.isMapViewAvailable = true;
    this.mapsPopupVisible = isVisible;
  }

  applyFacilityStatusLogic() {
    let shouldBeActive: boolean;

    if (this.facility.facilityDetail?.status === 'X') {
      shouldBeActive = false;
    } else {
      shouldBeActive = true;
    }

    // Only update if the value would actually change
    if (this.facility.activeFlag !== shouldBeActive) {
      this.facility.activeFlag = shouldBeActive;

      if (!shouldBeActive) {
        // Show notification that facility will be marked as inactive
        this.notificationService.alert("info", "Facility will be marked as inactive due to status 'X'.", null);
      }
    }
  }

}
